import request from '@/utils/request'
// 嘉宾接口

export function getPersonInfo (query) {
    return request({
        url: 'guangzhouGuest/info',
        method: 'get',
        params: query
    })
}

export function getArrivalInfo (query) {
    return request({
        url: 'guangzhouGuest/arrival',
        method: 'get',
        params: query
    })
}

export function getLeaveInfo (query) {
    return request({
        url: 'guangzhouGuest/leave',
        method: 'get',
        params: query
    })
}

export function getAccommodationInfo (query) {
    return request({
        url: 'guangzhouGuest/accommodation',
        method: 'get',
        params: query
    })
}

export function submitInfo (data) {
    return request({
        url: 'notcheck/register/guangzhouGuest',
        method: 'post',
        data
    })
}

export function updateArrival (data) {
    return request({
        url: 'guangzhouGuest/arrival',
        method: 'put',
        data
    })
}

export function updateLeave (data) {
    return request({
        url: 'guangzhouGuest/leave',
        method: 'put',
        data
    })
}

export function updateAccommodate (data) {
    return request({
        url: 'guangzhouGuest/accommodation',
        method: 'put',
        data
    })
}
